import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-shadow-fax-manage',
  templateUrl: './shadow-fax-manage.component.html',
  styleUrls: ['./shadow-fax-manage.component.scss'],
})
export class ShadowFaxManageComponent implements OnInit {
  shadowFaxData: any = {};
  carrierNameError: string;
  tokenError: string;

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals,  private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.api.getCarrierInfoById(this.user.accountOwnerId, this.route.snapshot.paramMap.get('id'), this.user.organizationId).subscribe((data: any) => {
      this.shadowFaxData = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.shadowFaxData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  tokenBlur() {
    this.tokenError = "";
    if (!this.shadowFaxData.authorization) {
      this.tokenError = 'Please enter token';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.tokenError = "";

    if (!this.shadowFaxData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.shadowFaxData.authorization) {
      this.tokenError = 'Please enter token';
    }
    if (this.carrierNameError != "" || this.tokenError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyAndSaveCarrierCredentials', {

      "authorization": this.shadowFaxData.authorization,
      "accountOwnerId": this.user.accountOwnerId,
      "carrierCode": this.shadowFaxData.carrierCode,
      "connectionName": this.shadowFaxData.connectionName,
      "organizationId": 1,
      "carrierId": this.shadowFaxData.carrierId

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shadow Fax', 'Update Successfully');
          this.router.navigate(['/admin/customerCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}
